export default __webpack_public_path__ + "static/media/642.543f171d.gif";